var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNewDeveloper = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "construction-barrier-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.7148 21.75C50.7148 20.9216 50.0433 20.25 49.2148 20.25H7.21484C6.38642 20.25 5.71484 20.9216 5.71484 21.75V37.5C5.71484 38.3284 6.38642 39 7.21484 39H49.2148C50.0433 39 50.7148 38.3284 50.7148 37.5V21.75ZM10.7148 14C13.4763 14 15.7148 11.7614 15.7148 9C15.7148 6.23858 13.4763 4 10.7148 4C7.95342 4 5.71484 6.23858 5.71484 9C5.71484 11.7614 7.95342 14 10.7148 14ZM45.7148 14C48.4763 14 50.7148 11.7614 50.7148 9C50.7148 6.23858 48.4763 4 45.7148 4C42.9534 4 40.7148 6.23858 40.7148 9C40.7148 11.7614 42.9534 14 45.7148 14Z",
    stroke: "#2153B1",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewDeveloper, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/newDeveloper.b2aa4040.svg";
export { ForwardRef as ReactComponent };